import {Box, InputLabel, Slider, Tooltip, Typography} from "@mui/material";
import {memo} from "react";
import {useTheme} from "@mui/material/styles";

const MhdDiscreteSlider = ({label,
  value,
  override,
  warning,
  error,
  onChange,
  units = '',
  step = '1',
  min=1,
  max=24}) => {
  const theme = useTheme()
  function valuetext(value: number) {
    return `${value}${units}`;
  }
  return (
    <Box>
      <InputLabel variant={error ? 'error' : 'primary'}>{label}</InputLabel>
      <Tooltip
        title={warning} arrow
        componentsProps={{
          tooltip: {sx: {backgroundColor: theme.palette.error.main, color: 'white'}},
          arrow: {sx: {color: theme.palette.error.main}},
        }}
      >
        <Slider
          defaultValue={value ? value : 1}
          value={value ? value : 1}
          getAriaValueText={valuetext}
          valueLabelDisplay="auto"
          size={"small"}
          // shiftStep={1}
          step={step}
          marks
          min={min}
          max={max}
          onChange={(e) => onChange(e.target.value)}
        />
      </Tooltip>
      {(override) &&
        <Typography variant='caption' color='error'>
          Modified: {override}
        </Typography>
      }
    </Box>
  );
};

export default memo(MhdDiscreteSlider);